import { getCountryCode } from '@/helpers/CountryCodeHelper';
import {
  LookUpRequest,
  RegisterUser,
  SecureWordRequest,
  verifyOtpRequest,
} from '@/types/EtiqaPlus';
import { SendOtpRequest } from '@/types/EtiqaPlus/SendOtpRequest';
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInterceptorInstance from './axiosInterceptorInstance';

export const fetchUsernamePolicy = createAsyncThunk(
  'username/fetchUsernamePolicy',
  async () => {
    try {
      const relativeUrl = 'smile/UsernameRule/';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const fetchPasswordPolicy = createAsyncThunk(
  'username/fetchPasswordPolicy',
  async () => {
    try {
      const relativeUrl = 'smile/PasswordRule/';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.get(apiUrl);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const accountLookUp = createAsyncThunk(
  'lookup/accountLookUp',
  async (form: LookUpRequest) => {
    try {
      const request: LookUpRequest = {
        encodedOrderId: form.encodedOrderId,
        username: form.username,
      };
      const relativeUrl = 'smile/LookupUser';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      if (response.data.succeeded) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Unknown error');
      }
    } catch (error) {
      return error;
    }
  },
);

export const requestOtp = createAsyncThunk(
  'application/requestOtp',
  async (form: SendOtpRequest) => {
    try {
      const request: SendOtpRequest = {
        encodedOrderId: form.encodedOrderId,
        countryCode: getCountryCode(),
        phoneNo: form.phoneNo,
        captchaToken: form.captchaToken,
        uniqueToken: form.uniqueToken,
      };
      const relativeUrl = 'smile/SendMobileOtp';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      if (response.data.succeeded) {
        return response.data;
      } else {
        throw new Error(response.data.message || 'Unknown error');
      }
    } catch (error) {
      return error;
    }
  },
);

export const registerUser = createAsyncThunk(
  'register/registerUser',
  async (form: RegisterUser) => {
    try {
      const request: RegisterUser = {
        encodedOrderId: form.encodedOrderId,
        username: form.username,
        password: form.password,
        secretWord: form.secretWord,
        otpToken: form.otpToken,
      };
      const relativeUrl = 'smile/RegisterUser';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const verifyOtp = createAsyncThunk(
  'application/verifyOtp',
  async (form: verifyOtpRequest) => {
    try {
      const request: verifyOtpRequest = {
        encodedOrderId: form.encodedOrderId,
        otp: form.otp,
      };
      const relativeUrl = 'smile/VerifyMobileOtp';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      return response.data;
    } catch (error) {
      return error;
    }
  },
);

export const secretWord = createAsyncThunk(
  'lookup/secretWord',
  async (form: SecureWordRequest) => {
    try {
      const request: SecureWordRequest = {
        encodedOrderId: form.encodedOrderId,
        secretWord: form.secretWord,
        username: form.username,
      };
      const relativeUrl = 'smile/ValidateSecret';
      const apiUrl = `/application/?relativeUrl=${relativeUrl}`;
      const response = await axiosInterceptorInstance.post(apiUrl, request);
      if (response.data.succeeded) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Unknown error');
      }
    } catch (error) {
      return error;
    }
  },
);
